import React from 'react';
import { useMediaQuery } from '@mui/material';
import Info from './Info';
import SubInfo from './SubInfo';

interface CaseStudySectionProps {
  title: string;
  content: string;
}

const CaseStudySection = ({ title, content }: CaseStudySectionProps) => {
  const isLessThan1280 = useMediaQuery('(max-width: 1280px)');
  const isLessThan640 = useMediaQuery('(max-width: 640px)');

  return (
    <div className="space-y-6">
      <Info 
        variant={'h2'}
        className="text-4xl font-bold"
        typographyStyles={{
          fontSize: isLessThan1280 ? (isLessThan640 ? 32 : 36) : 42,
        }}>
        {title}
      </Info>
      <SubInfo 
        containerClasses="text-xl leading-relaxed"
        typographyStyles={{ 
          fontFamily: 'var(--fontPrimary)',
          color: '#728F8B'
        }}>
        {content}
      </SubInfo>
    </div>
  );
};

export default CaseStudySection;

